import React from "react";
import { SlidePages } from "../../components/slidePages";
import { Interventions } from "../../components/serviceDetails/intervention";
import toi1 from "../../assets/images/toi1.png";
import toi2 from "../../assets/images/toi2.png";
import toi3 from "../../assets/images/toi3.png";
import { Partenaire } from "../../components/home/nosPartenaire";
import { Realisation } from "../../components/home/realisation";
import { Prestations } from "../../components/home/prestations";
import { DemandeDevis } from "../../components/home/demandeDevis";

import rea1 from "../../assets/images/rea16.png";
import rea2 from "../../assets/images/rea17.png";
import rea3 from "../../assets/images/rea18.png";
import rea4 from "../../assets/images/rea19.png";
import rea5 from "../../assets/images/rea20.png";
import rea6 from "../../assets/images/rea21.png";
export const ToiturePage = () => {
  const prestations = [
    {
      icon: toi1,
      text: "Isolation des combles perdus (soufflage ou déroulé)",
    },
    {
      icon: toi2,
      text: "Isolation des rampants (sous toiture)",
    },
    {
      icon: toi3,
      text: "Isolation par l’extérieur (sarking)",
    },
  ];
  const realisations = [
    {
      image: rea1,
      text: "Isolation de toiture",
      link: "/toiture",
    },
    {
      image: rea2,
      text: "Isolation de toiture",
      link: "/toiture",
    },
    {
      image: rea3,
      text: "Isolation de toiture",
      link: "/toiture",
    },
    {
      image: rea4,
      text: "Isolation de toiture",
      link: "/toiture",
    },
    {
      image: rea5,
      text: "Isolation de toiture",
      link: "/toiture",
    },
    {
      image: rea6,
      text: "Isolation de toiture",
      link: "/toiture",
    },
  ];
  return (
    <div>
      {" "}
      <SlidePages
        title={"Isolation de toiture"}
        description={
          "30 % des pertes de chaleur passent par la toiture. Isoler vos combles ou votre toit est une priorité pour toute rénovation énergétique."
        }
      />
      <Interventions
        title={"Solutions proposées"}
        description={"Simple, efficace, durable"}
        prestations={prestations}
      />
      <Partenaire />
      <Realisation realisations={realisations} />
      <DemandeDevis title={"Demandez un diagnostic toiture offert !"} />
      <Prestations
        title={"D’autres services"}
        description={
          "Des solutions durables pour un habitat plus beau, plus sain et moins énergivore."
        }
      />
    </div>
  );
};
